import api from "../../utils/apiUser";
import { desempaquetarLista } from "../../utils/listaPaginada";

export const getClientes = async ({
  limit = 500,
  offset = 0,
  incluirInactivos = false,
} = {}) => {
  const params = { limit, offset };
  if (incluirInactivos) params.incluir_inactivos = 1;

  const res = await api.get("/api/clientes", { params });
  return desempaquetarLista(res.data);
};

export const crearCliente = async (data) => {
  const res = await api.post("/api/clientes", data);
  return res.data;
};

export const actualizarCliente = async (id, data) => {
  const res = await api.put(`/api/clientes/${id}`, data);
  return res.data;
};

/* Dar de baja y reactivar. No hay borrado: los pedidos y las direcciones
   del cliente apuntan a su ficha, y un pedido sin cliente no se puede
   reclamar ni auditar. */
export const cambiarEstadoCliente = async (id, activo) => {
  const res = await api.put(`/api/clientes/${id}/estado`, { activo });
  return res.data;
};
